if (!customElements.get('tte-controller-model')) {
  customElements.define('tte-controller-model', class extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('select');
      this.originalImages = new Map();
      this.handleChange = () => this.sync(true);
      this.handleRestore = () => this.sync(false);
      this.select.addEventListener('change', this.handleChange);
      window.addEventListener('pageshow', this.handleRestore);
      this.sync(false);
    }

    disconnectedCallback() {
      this.select.removeEventListener('change', this.handleChange);
      window.removeEventListener('pageshow', this.handleRestore);
    }

    sync(showImage) {
      const model = this.select.value === 'PS4' ? 'PS4' : 'PS5';
      const mobileForm = document.getElementById(`tte-mobile-form-${this.dataset.section}`);
      const mobileProperty = mobileForm?.querySelector('[data-tte-model-property]');
      if (mobileProperty && mobileProperty.value !== model) {
        mobileProperty.value = model;
        mobileProperty.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const label = mobileForm?.closest('tte-mobile-purchase')?.querySelector('[data-tte-model-label]');
      if (label) label.textContent = model;

      const gallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
      const modal = document.getElementById(`ProductModal-${this.dataset.section}`);
      this.swapMedia(gallery, modal, this.dataset.mediaId, this.dataset.ps4Image, this.dataset.ps4Alt, model);
      this.swapMedia(gallery, modal, this.dataset.boardMediaId, this.dataset.ps4BoardImage, this.dataset.ps4BoardAlt, model);

      if (showImage && gallery?.setActiveMedia) {
        gallery.setActiveMedia(`${this.dataset.section}-${this.dataset.mediaId}`, false);
      }
    }

    swapMedia(gallery, modal, id, url, alt, model) {
      if (!id || !url) return;
      const mediaId = `${this.dataset.section}-${id}`;
      const images = [
        ...(gallery?.querySelectorAll(`[data-media-id="${mediaId}"] img, [data-target="${mediaId}"] img`) || []),
        ...(modal?.querySelectorAll(`img[data-media-id="${id}"]`) || [])
      ];

      images.forEach((image) => {
        if (!this.originalImages.has(image)) {
          this.originalImages.set(image, {
            src: image.getAttribute('src'),
            srcset: image.getAttribute('srcset'),
            alt: image.getAttribute('alt')
          });
        }
        const original = this.originalImages.get(image);
        const attributes = model === 'PS4' ? {
          src: this.ps4Url(original.src, url),
          srcset: original.srcset?.split(',').map((candidate) => {
            const [sourceUrl, descriptor] = candidate.trim().split(/\s+/);
            return sourceUrl ? `${this.ps4Url(sourceUrl, url)}${descriptor ? ` ${descriptor}` : ''}` : '';
          }).filter(Boolean).join(', '),
          alt
        } : original;
        Object.entries(attributes).forEach(([name, value]) => {
          if (value == null) image.removeAttribute(name);
          else if (image.getAttribute(name) !== value) image.setAttribute(name, value);
        });
      });
    }

    ps4Url(original, replacement) {
      const source = new URL(original || replacement, window.location.origin);
      const target = new URL(replacement, window.location.origin);
      ['width', 'height', 'crop'].forEach((key) => {
        if (source.searchParams.has(key)) target.searchParams.set(key, source.searchParams.get(key));
      });
      return target.href;
    }
  });
}

